import React from 'react';
import "./MegaMenuHover.css"

export const MegaMenuHover = (props) => {
  return (
    <div className='container' id='mega-menu-hover'>
      <div className="row service-description">
        <h3>{props.service}</h3>
        <p>{props.serviceDescription}</p>
        <hr />
      </div>
      <div className="row service-img">
        <img src={props.serviceImg} alt=".." style={{height:"40vh"}}/>
        <h4>{props.imageText}</h4>
      </div>
    </div>
  )
}


